module.exports = __webpack_public_path__ + "static/media/play-store-cache-es.bdfd7189.png";